<template>
  <div class="initData">
    <div>
      <h1>基础数据</h1>
      <el-row class="rowBox" :gutter="20">
        <el-col :span="6" class="one">
          <div class="card">
            <p><i class="iconfont icon-back-zuzhiguanli1" />组织管理</p>
            <div class="buttonBox">
              <el-link type="primary" :underline="false" v-if="transforDing" class="setHiden" @click="iExportDing(1)">
                <el-tooltip class="item" effect="dark" content="下载钉钉组织" placement="top" :disabled="setDiabled(1)">
                  <span>下载钉钉组织</span>
                </el-tooltip>
              </el-link>
              <el-link type="primary" class="setHiden" :underline="false" @click="iExport" :class="transforDing ? 'marginLeft20' : ''">
                <el-tooltip class="item" effect="dark" content="下载组织模板" placement="top" :disabled="setDiabled(1)"> <span>下载组织模板 </span></el-tooltip>
              </el-link>
              <el-link type="primary" :underline="false" @click="iImport" class="marginLeft20">导入模板</el-link>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="one">
          <div class="card">
            <p><i class="iconfont icon-back-jiaoseguanli" />角色管理</p>
            <div class="buttonBox">
              <el-link type="primary" class="setHiden" :underline="false" @click="iExportRole">
                <el-tooltip class="item" effect="dark" content="下载角色模板" placement="top" :disabled="setDiabled(1)"
                  ><span>下载角色模板</span></el-tooltip
                ></el-link
              >
              <el-link type="primary" :underline="false" @click="iImportRole" class="marginLeft20">导入模板</el-link>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="one">
          <div class="card">
            <p>
              <svg aria-hidden="true" class="icon svg-icon iconStyle">
                <use xlink:href="#icon-back-yonghuguanli"></use>
              </svg>
              用户管理
            </p>
            <div class="buttonBox">
              <el-link type="primary" :underline="false" class="setHiden" v-if="transforDing" @click="iExportDing(2)">
                <el-tooltip class="item" effect="dark" content="下载钉钉用户" placement="top" :disabled="setDiabled(1)"
                  ><span>下载钉钉用户</span></el-tooltip
                ></el-link
              >
              <el-link type="primary" :underline="false" @click="iExportUser" class="setHiden" :class="transforDing ? 'marginLeft20' : ''">
                <el-tooltip class="item" effect="dark" content="下载用户模板" placement="top" :disabled="setDiabled(1)"
                  ><span>下载用户模板</span></el-tooltip
                ></el-link
              >
              <el-link type="primary" :underline="false" @click="iImportUser" class="marginLeft20">导入模板</el-link>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="one">
          <div class="card">
            <p><i class="iconfont icon-back-wanglaidanweiguanli" />往来单位管理</p>
            <div class="buttonBox">
              <el-link type="primary" :underline="false" @click="iExportWl"> 下载往来单位模板</el-link>
              <el-link type="primary" :underline="false" @click="iImportWl" class="marginLeft20">导入模板</el-link>
            </div>
          </div>
        </el-col>
      </el-row>
      <h1 style="margin-bottom: 0">业务数据</h1>
      <div class="ywData">
        <template v-for="(item, index) in ywDataList">
          <yw-data-comps class="ywData_item" :style="{ marginLeft: index % 4 == 0 ? 0 : '20px' }" :key="index" :tableData="item"></yw-data-comps>
        </template>
      </div>
    </div>
    <!-- 组织导入对话框 -->
    <el-dialog
      width="70%"
      style="height: 500px"
      title="导入组织"
      class="sp-manager__dialog"
      :visible="importShow"
      :close-on-click-modal="false"
      :before-close="beforeCloseimport"
      @dialogclose="beforeCloseimport"
      :destroy-on-close="true"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">导入组织</span>
      </div>
      <eip-import-material
        model-name="importList"
        permission="w"
        propConf='[{"name":"prop1"}]'
        accept="xlsx,xls"
        limit="1"
        displayType="table"
        :importsuccess="true"
        :multiple="false"
        :importurl="importurl"
        :downloadable="false"
      >
        <span slot="labeldesc">组织模板</span>
      </eip-import-material>
      <span slot="footer" class="dialog-footer">
        <el-link type="primary" :underline="false" @click="beforeCloseimport">完 成</el-link>
      </span>
    </el-dialog>

    <!-- 用户导入对话框 -->
    <el-dialog
      width="70%"
      style="height: 500px"
      title="导入用户"
      class="sp-manager__dialog"
      :visible="importShowUser"
      :close-on-click-modal="false"
      :before-close="beforeCloseimportUser"
      @dialogclose="beforeCloseimportUser"
      :destroy-on-close="true"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">导入用户</span>
      </div>
      <eip-import-material
        model-name="importList"
        permission="w"
        propConf='[{"name":"prop1"}]'
        accept="xlsx,xls"
        limit="1"
        displayType="table"
        :importsuccess="true"
        :multiple="false"
        :importurl="importurlUser"
        :downloadable="false"
      >
      </eip-import-material>
      <el-row class="import_row">
        <span style="color: red">导入须知: </span>
        <span>
          导入数据需按模板指定格式进行导入：1、姓名、帐号等字段为必填字段，必填字段请按照批注严格填写；2、组织岗位导入规则：每个用户绑定一个主组织(部门)，每个部门绑定一个主负责人；根据性质填写岗位和组织，性质=组织
          填写 组织编码，组织名称，是否是负责人，是否是主组织，性质=岗位 填写 岗位编码，岗位名称 3、邮箱、手机号、生日
          格式必须符合标准，将不导入不符合规范的邮箱数据；4、导入后如果有未导入的信息，将会自动下载成excel文件，请认真核对；5、填写所属角色时，请确保模板中的流程角色至少匹配一名用户；6、不要编辑数据字典中的内容
        </span>
      </el-row>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button type="primary" element-loading-text="拼命导入中" @click="beforeCloseimportUser">完 成</el-button>
      </div>
    </el-dialog>

    <!-- 角色导入对话框 -->
    <el-dialog
      width="70%"
      style="height: 500px"
      title="导入角色"
      class="sp-manager__dialog"
      :visible="importShowRole"
      :close-on-click-modal="false"
      :before-close="beforeCloseimportRole"
      @dialogclose="beforeCloseimportRole"
      :destroy-on-close="true"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">导入角色</span>
      </div>
      <eip-import-material
        model-name="importList"
        permission="w"
        propConf='[{"name":"prop1"}]'
        accept="xlsx,xls"
        limit="1"
        displayType="table"
        :importsuccess="true"
        :multiple="false"
        :importurl="importurlRole"
        :downloadable="false"
      >
        <span slot="labeldesc">导入角色</span>
      </eip-import-material>
      <span slot="footer" class="dialog-footer">
        <el-link type="primary" :underline="false" @click="beforeCloseimportRole">完 成</el-link>
      </span>
    </el-dialog>
    <!-- 往来单位导入对话框 -->
    <el-dialog
      width="70%"
      style="height: 500px"
      title="导入往来单位"
      class="sp-manager__dialog"
      :visible="importShowWl"
      :close-on-click-modal="false"
      :before-close="beforeCloseimportWl"
      @dialogclose="beforeCloseimportWl"
      :destroy-on-close="true"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">导入往来单位</span>
      </div>
      <eip-import-material
        model-name="importList"
        permission="w"
        propConf='[{"name":"prop1"}]'
        accept="xlsx,xls"
        limit="1"
        displayType="table"
        :multiple="false"
        :importsuccess="true"
        :importurl2="importurlWl"
        :downloadable="false"
      >
        <span slot="labeldesc">往来单位</span>
      </eip-import-material>
      <span slot="footer" class="dialog-footer">
        <el-link type="primary" :underline="false" @click="beforeCloseimportWl">完 成</el-link>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import eipImportMaterial from '@/components/eipControl/EipImportMaterial.vue'
import ywDataComps from './ywData'
import req from '@/request.js'
export default {
  data() {
    return {
      importShow: false,
      importShowUser: false,
      importShowRole: false,
      importShowWl: false,
      importurl: '/api/org/v1/importXlsx',
      importurlRole: '/api/role/v1/importXlsx',
      importurlWl: '/system/customer_register/importXlsx',
      importurlUser: '/api/user/v1/importXlsx',
      ywDataList: [],
      transforDing: false
    }
  },
  components: {
    eipImportMaterial,
    ywDataComps
  },
  mounted() {
    //判断用户同步手机号
    let url = window.context.portal + '/portal/sysExternalUnite/v1/listJson'
    let param = {
      pageBean: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      querys: []
    }
    req.post(url, param).then((res) => {
      let response = res.data.rows
      response.forEach((item) => {
        if (item.type == 'dingtalk') {
          this.transforDing = true
        }
      })
    })
    this.getYwDataList()
  },
  methods: {
    setDiabled(type) {
      const data = document.getElementsByClassName('setHiden')[0] ? document.getElementsByClassName('setHiden')[0].clientWidth : 84
      return data > 84
    },
    getYwDataList() {
      this.$http.get('${business}/system/data_import/getDataImportList').then((resp) => {
        this.ywDataList = resp.data.value
      })
    },
    //钉钉用户组织导出
    iExportDing(type) {
      let url = ''
      if (type == 1) {
        url = '${third}/dingtalk/exportModelOrg'
      }
      if (type == 2) {
        url = '${third}/dingtalk/exportModelUser'
      }
      this.$http.get(url, 'arraybuffer').then((res) => {})
    },
    // 往来单位管理--导出
    iExportWl() {
      this.$http.get('${business}/system/context/template?fileKey=export-template/往来单位模板.xlsx', 'arraybuffer').then((resp) => {})
    },
    // 往来单位管理--打开导入对话框

    iImportWl() {
      this.importShowWl = true
    },
    // 往来单位管理--关闭导入对话框
    beforeCloseimportWl() {
      this.importShowWl = false
    },
    // 角色管理--导出
    iExportRole() {
      this.$http.get('${business}/system/context/template?fileKey=export-template/角色导入模板.xlsx', 'arraybuffer').then((resp) => {})
    },
    // 角色管理--打开导入对话框
    iImportRole() {
      this.importShowRole = true
    },
    // 角色管理--关闭导入对话框
    beforeCloseimportRole() {
      this.importShowRole = false
    },

    // 用户管理--导出
    iExportUser() {
      this.$http.get('${business}/system/context/template?fileKey=export-template/用户模板.xlsx', 'arraybuffer').then((resp) => {})
    },
    // 用户管理--打开导入对话框
    iImportUser() {
      this.importShowUser = true
    },
    // 用户管理--关闭导入对话框
    beforeCloseimportUser() {
      this.importShowUser = false
    },
    // 组织管理--导出
    iExport() {
      this.$http.get('${business}/system/context/template?fileKey=export-template/组织部门导入模板.xlsx', 'arraybuffer').then((resp) => {})
    },
    // 组织管理--打开导入对话框
    iImport() {
      this.importShow = true
    },
    // 组织管理--关闭导入对话框
    beforeCloseimport() {
      this.importShow = false
    }
  }
}
</script>
<style lang="scss">
.ywData {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  .ywData_item {
    width: calc((100% - 60px) / 4);
    height: 152px;
    margin: 20px 0 0;
    background: #ffffff;
    border-radius: 4px;
    /deep/.el-link--primary {
      color: #155bd4;
    }
    .ywData_item_title {
      font-weight: bold;
      border-bottom: 1px solid #e0e0e0;
      padding: 12px 10px;
      margin: 0;
      font-size: 16px;
      color: rgba(51, 51, 51, 100);
    }
  }
}
</style>
<style lang="scss" scoped>
h1 {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin: 0 0 10px;
  padding: 0 0 0 13px;
  border-left: 3px solid #155bd4;
}
/deep/.el-link--primary {
  color: #155bd4;
}
p {
  padding: 0;
  margin: 0;
  line-height: 1.5;
}
.initData {
  padding: 0;
  background: #f2f3f5;
  margin-left: -20px;
  margin-right: -20px;
  padding: 9px 20px 0 9px;
  overflow-y: scroll;
  height: calc(100% - 10px);
}
.one {
}
.card {
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
}
.iconStyle {
  width: 24px;
  margin-right: 10px;
  height: 24px;
}
.card i {
  font-size: 24px;
  color: #155bd4;
  margin-right: 10px;
}
.card p {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: rgba(51, 51, 51, 100);
  font-size: 16px;
  font-weight: bold;
  padding: 10px 10px 9px;
  line-height: 24px;
  border-bottom: 1px solid #e0e0e0;
}
.buttonBox {
  text-align: left;
  padding: 15px 9px;
  display: flex;
  .setHiden {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 30%;
    display: block;
  }
}
.blueBtn {
  height: 30px;
  border-radius: 4px;
  color: rgba(50, 145, 248, 100);
  font-size: 14px;
  border: 1px solid rgba(50, 145, 248, 100);
  padding: 0 10px;
}
.blueBtn:hover,
.blueBtn:active,
.blueBtn:visited {
  height: 30px;
  border-radius: 4px;
  color: rgba(50, 145, 248, 100);
  font-size: 14px;
  border: 1px solid rgba(50, 145, 248, 100);
  background-color: #fff;
  padding: 0 10px;
}
.grayBtn {
  height: 30px;
  border-radius: 4px;
  color: rgba(51, 51, 51, 0.6);
  font-size: 14px;
  border: 1px solid rgba(187, 187, 187, 100);
  padding: 0 10px;
}
.grayBtn:hover,
.grayBtn:active,
.grayBtn:visited {
  height: 30px;
  border-radius: 4px;
  color: rgba(51, 51, 51, 0.6);
  font-size: 14px;
  border: 1px solid rgba(187, 187, 187, 100);
  padding: 0 10px;
  background-color: #fff;
}
.rowBox {
  margin-bottom: 20px;
}
</style>
